module.exports = __webpack_public_path__ + "img/example.628a2810.png";